<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'user.userDeactivationDialog.headline' | translate }}</span>
  <button mat-icon-button [mat-dialog-close]="false">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>
<div>
  <mat-dialog-content>
    {{ 'user.userDeactivationDialog.text' | translate }}

    <div class="confirmation-data">
      <div>{{ 'user.firstName' | translate }}:</div>
      <div>{{ data.user.firstName }}</div>

      <div>{{ 'user.lastName' | translate }}:</div>
      <div>{{ data.user.lastName }}</div>

      <div>{{ 'user.email' | translate }}:</div>
      <div>{{ data.user.email }}</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      <mat-icon>check</mat-icon>
      {{ 'core.confirmBtn' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="false" color="primary">
      <mat-icon>close</mat-icon>
      {{ 'core.cancelBtn' | translate }}
    </button>
  </mat-dialog-actions>
</div>

